export default "__VITE_ASSET__DDGKdaEc__"